import background from '../../../assests/internship/intern-background-home.png'
import internship2 from '../../../assests/internship/internship-home2.png'
import internship5 from '../../../assests/internship/internship-home4.png'
import image1 from '../../../assests/internship/Live coaching.png'
import image2 from '../../../assests/internship/Beginner Level.png'
import image3 from '../../../assests/internship/Official Certification.png'
import image4 from '../../../assests/internship/One-on-one sessions.png'
import image5 from '../../../assests/internship/placement assistance.png'
import image6 from '../../../assests/internship/Top Industry Trainers.png'
import person2 from '../../../assests/internship/person2.png'
import '../internship.css'

import { FacebookFilled, InstagramOutlined, LinkedinFilled, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons'

import about from "../../../assests/about_image.png";
import Header from '../../componets/header/header'
import Footer from '../../componets/footer/footer'
function Internshiponsite() {
    const handleDownload = () => {
        // const pdfUrl = new URL("../../assests/internship/Onsite_Digital_Marketing_Brochure.pdf", import.meta.url).href;
        const link = document.createElement("a");
        // link.href = pdfUrl;
        link.download = "Onsite_Digital_Marketing_Brochure.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const syllabusItems = [
        ['Digital Marketing Introduction', 'Website Planning & Strategy', 'Search Engine Optimization', 'Google Analytics Setup', 'Social Media Strategy', 'Content Creation Workshop', 'Email Marketing Campaigns', 'Live Project Implementation', 'Campus Brand Building'],
        ['Advanced SEO Techniques', 'Google Ads Management', 'Facebook & Instagram Marketing', 'YouTube Marketing', 'LinkedIn for Education', 'Campus Event Promotion', 'Student Engagement Strategies', 'Online Reputation Management'],
        ['Influencer Marketing', 'Marketing Automation', 'Lead Generation for Education', 'Admission Campaign Strategies', 'Alumni Engagement', 'Campus Digital Transformation', 'Performance Tracking', 'Industry Certification'],
    ];
    return (
        <div>
            <Header />
            <div >
                <section className="hero">
                    <div className="text_values">

                        <h1>On-Campus Digital Marketing Training, Delivered by Papa Digital Academy</h1>


                        <div className="social-icons">
                            <a href='https://www.facebook.com/papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <FacebookFilled style={{ color: "white" }} />
                            </a>
                            <a href='https://www.instagram.com/papaekmpapa/' target="_blank" rel="noopener noreferrer">
                                <InstagramOutlined className="fab fa-instagram" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.youtube.com/@Papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <YoutubeOutlined className="fab fa-youtube" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.linkedin.com/company/papa-digital-solution/posts/?feedView=all' target="_blank" rel="noopener noreferrer">
                                <LinkedinFilled className="fab fa-linkedin-in" style={{ color: "white" }} />
                            </a>
                            <a href='https://wa.me/919562121117' target="_blank" rel="noopener noreferrer">
                                <WhatsAppOutlined className="fab fa-whatsapp" style={{ color: "white" }} />
                            </a>
                        </div>
                    </div>

                    <img src={background} alt="Group of Students" style={{
                        position: 'absolute',
                        bottom: 0,
                        maxWidth: '100%',
                        height: 'auto',
                        zIndex: 2,
                    }} />


                </section>
                <section className="overlay-section">
                    <img src={internship2} alt="On-Campus Digital Marketing" className="background-image" />
                    <div className="overlay-content">
                        <h2>Best On-Campus Digital Marketing Training for Schools & Colleges</h2>
                        <p>At Papa Digital Academy, we bring world-class digital marketing education directly to your campus. Our specialized on-site training programs are
                            designed to empower students with industry-relevant skills without leaving their familiar learning environment.
                            We work closely with educational institutions to deliver customized training that fits seamlessly into academic schedules.

                            Our on-campus programs have helped thousands of students across various schools and colleges gain practical digital marketing skills
                            while continuing their regular studies. We adapt our curriculum to complement existing academic programs,
                            ensuring students get the best of both worlds - academic excellence and industry-ready skills.
                        </p>
                        <p>
                            What makes our on-campus training unique is the convenience and personalized attention we provide.
                            Students learn in their comfortable campus environment with their peers, creating a collaborative learning atmosphere.
                            Our expert trainers bring years of industry experience directly to your institution,
                            making quality digital marketing education accessible and affordable for every student.

                            Partner with Papa Digital Academy and transform your campus into a digital marketing learning hub that prepares students for the future job market.
                        </p>
                    </div>
                </section>
                <section className="course-audience-section">
                    <h2>WHO SHOULD ATTEND THE COURSE</h2>
                    <div className="audience-cards-container">
                        <div className="audience-card">
                            <span className="card-number">1</span>
                            <h3>For School Students</h3>
                            <h4>Early Career Advantage!</h4>
                            <p>
                                Give your students a head start in their career journey! Our school-friendly digital marketing programs are designed to introduce
                                young minds to the digital world through fun, interactive sessions that complement their academic studies.
                                Let's prepare them for the digital future right from their school campus!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">2</span>
                            <h3>For College Students</h3>
                            <h4>Bridge the Skills Gap!</h4>
                            <p>
                                Enhance your college curriculum with practical digital marketing skills! Our on-campus training provides college students with
                                industry-relevant knowledge that makes them job-ready upon graduation. Perfect for students who want to gain
                                competitive advantage while pursuing their degree!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">3</span>
                            <h3>For Educational Institutions</h3>
                            <h4>Upgrade Your Curriculum!</h4>
                            <p>
                                Want to offer cutting-edge digital marketing education to your students? Our comprehensive on-campus training programs help
                                educational institutions provide modern, industry-aligned courses that enhance student employability and
                                institutional reputation in the digital age!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">4</span>
                            <h3>For Faculty Development</h3>
                            <h4>Empower Your Educators!</h4>
                            <p>
                                Equip your teaching staff with digital marketing knowledge! Our specialized faculty training programs help educators understand
                                and teach digital marketing concepts effectively. Enable your faculty to guide students in the rapidly evolving digital landscape
                                with confidence and expertise!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">5</span>
                            <h3>For Student Clubs & Organizations</h3>
                            <h4>Boost Campus Engagement!</h4>
                            <p>
                                Perfect for student clubs, societies, and organizations looking to enhance their digital presence! Learn how to effectively promote
                                campus events, build online communities, and engage with fellow students through strategic digital marketing
                                techniques tailored for campus life!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">6</span>
                            <h3>For Campus Entrepreneurs</h3>
                            <h4>Launch Your Startup Journey!</h4>
                            <p>
                                Have a business idea while studying? Our on-campus digital marketing training helps student entrepreneurs learn how to
                                market their ventures effectively. Discover how to build your brand, reach customers, and grow your startup
                                right from your campus environment!
                            </p>
                        </div>
                    </div>
                </section>
                <div className="about-section-wrapper">
                    <div className="about-left">
                        <div className="internship-images">
                            <img src={person2} alt="internship-home" />
                        </div>

                    </div>


                    <div className="about-right">
                        <h6 className="about-subtitle">About Us</h6>
                        <h2 className="about-title">
                            WHO WE ARE
                        </h2>
                        <div className="about-summary">

                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we are pioneers in bringing quality digital marketing education directly to educational institutions.
                                    We are your trusted partners in transforming traditional campus learning with modern digital skills.
                                    Our mission is to bridge the gap between academic education and industry requirements by delivering practical,
                                    hands-on digital marketing training right at your campus.
                                </p>
                                <p>
                                    Founded on the principles of accessible education, innovation, and student success, we pride
                                    ourselves on delivering exceptional on-campus training programs through industry-standard practices and expert
                                    guidance. Our team consists of experienced digital marketing professionals with more than 5+ years
                                    of expertise in both education and practical marketing. With our extensive experience in campus training, Papa
                                    Digital Academy has become the preferred choice for schools and colleges looking to provide their students with
                                    cutting-edge digital marketing skills without the hassle of external arrangements.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="internship-offer-section">
                    <div className="internship-home3">
                        <div className="internship-images">
                            <img src={internship5} alt="internship-home" />
                        </div>

                        <div className="internship-texts">
                            <h2 className="about-title">WHAT WE OFFER</h2>
                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we provide more than just classroom training—we bring a complete on-campus digital marketing
                                    ecosystem to your institution. Our programs include mentorship, practical workshops,
                                    and career guidance from industry professionals, all delivered at your campus. Our goal is to create a
                                    digital marketing culture within educational institutions through comprehensive, engaging programs.
                                    Here's what makes our on-campus training special:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Campus-Specific Live Projects:</strong> Students work on real digital marketing projects relevant to their
                                        institution, including campus event promotion, admission campaigns, and student engagement strategies.
                                    </li>
                                    <li>
                                        <strong>Flexible Scheduling & Academic Integration:</strong> We work around academic calendars and class schedules,
                                        ensuring our training complements rather than disrupts regular studies. Programs can be integrated into existing curriculum or offered as supplementary courses.
                                    </li>
                                    <li>
                                        <strong>Expert On-Site Mentorship:</strong> Our experienced trainers come directly to your campus, providing personalized
                                        guidance and hands-on support. Students benefit from face-to-face interactions and immediate feedback on their work.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="timings-section">
                    <h2 className="about-title">PROGRAM SCHEDULE</h2>
                    <div className="timings-top">
                        <div className="timing-box">
                            <div className="timing-icon">🏫</div>
                            <p><strong>Flexible campus-based sessions, 2-3 hours per week.</strong></p>
                        </div>
                        <div className="timing-box">
                            <div className="timing-icon">🏫</div>
                            <p><strong>3 Months On-Campus Training Program</strong></p>
                        </div>
                    </div>

                    <div className="timings-features">
                        {[
                            { icon: image1, text: 'On-site live training' },
                            { icon: image2, text: 'Student-friendly approach' },
                            { icon: image3, text: 'Campus certification' },
                            { icon: image4, text: 'Personalized campus sessions' },
                            { icon: image5, text: '100% campus placement support' },
                            { icon: image6, text: 'Expert campus trainers' },
                        ].map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">
                                    <img src={feature.icon} alt={feature.text} style={{ width: 32, height: 32 }} />
                                </div>
                                <p>{feature.text}</p>
                            </div>
                        ))}
                    </div>

                </section>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Choose Our On-Campus Program?</h2>
                        <ul>
                            <li>Training delivered directly at your institution</li>
                            <li>Curriculum tailored to complement academic programs</li>
                            <li>Flexible scheduling that works with academic calendars</li>
                            <li>Campus-specific projects and real-world applications</li>
                            <li>Expert trainers with educational institution experience</li>
                            <p>At Papa Digital Academy, we believe in making quality digital marketing education accessible
                                to every student, right where they study. Join us in creating a digitally empowered campus
                                community that's ready for the future!</p>
                        </ul>
                    </div>
                </div>
                <section className="syllabus-section">
                    <h2 className="about-title">CAMPUS CURRICULUM</h2>
                    <div className="syllabus-columns">
                        {syllabusItems.map((column, colIndex) => (
                            <ul className="syllabus-column" key={colIndex}>
                                {column.map((item, index) => (
                                    <li key={index} className="syllabus-item">
                                        <span className="syllabus-icon">🏫</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </section>
                {/* 
                <div>
                    <h3 onClick={handleDownload} className="blinking-text">
                        For Institution Partnership Info <span style={{ color: "#00aaff" }}>CLICK HERE</span>
                    </h3>
                </div> */}
            </div>
            <Footer />
        </div>
    )
}

export default Internshiponsite